import React, {useState, useEffect} from 'react';

import CloseButton from './CloseButton';
import {cx} from '../util';

const DismissibleCallout = ({children, className, id}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(`dismiss_callout: ${id}`);
    if (dismissed === 'true') {
      setIsVisible(false);
    }
  }, [id]);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem(`dismiss_callout: ${id}`, 'true');
  };

  if (!isVisible) return null;

  return (
    <div className={cx('relative flex flex-col md:rounded-lg md:shadow-sm bg-gray-50 border border-gray-200 text-gray-900 p-4', className)}>
      <CloseButton
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none"
      />
      <div className="flex justify-between items-center mr-3">
        <span>{children}</span>
      </div>
    </div>
  );
};

export default DismissibleCallout;
